module.exports = __webpack_public_path__ + "static/media/Arrow-right.98750ce7.svg";